getBuiltinModule